const config = {
  placeholder: false, // when true (and only on the prd env), replaces the registration flow with the Placeholder page

  event: {
    title: 'Portland English Country Dance Ball',
    titleWithYear: 'Portland English Country Dance Ball 2026', // must match backend config
    location: 'Oaks Park Dance Pavilion, Portland, Oregon',
    date: 'November 6-7-8, 2026',
    timezone: 'America/Los_Angeles'
  },

  calendar: {
    title: 'Portland English Country Dance Ball',
    description: 'More details at https://portlandecdball.info',
    location: 'Oaks Park Dance Pavilion, Portland, Oregon',
    start: '2026-11-06T19:30:00-07:00', // ISO 8601 format
    end: '2026-11-08T14:00:00-07:00' // ISO 8601 format
  },

  contacts: {
    info: 'registrar@portlandecdball.info',
    tech: 'webmaster@portlandecdball.info',
    housing: 'hospitality@portlandecdball.info'
  },

  links: {
    info: 'portlandecdball.info',
    policies: {
      covid: 'pcdc.fun/covid19',
      safety: ''
    }
  },

  // must match the companion static site's navbar (site.config.ts & globals.css in the static site repo)
  navbar: {
    siteName: 'Portland ECD Ball',
    brand: false as string | false, // optional logo image path (e.g. '/logo.png') shown before siteName; false to omit
    accent: {
      light: '#2563eb',
      dark: '#60a5fa'
    },
    links: [
      { label: 'Home', path: '/' },
      { label: 'Welcome', path: '/welcome' },
      { label: 'Performers', path: '/staff' },
      { label: 'Workshops', path: '/workshops' },
      { label: 'Schedule', path: '/schedule' },
      { label: 'Dances', path: '/dances' },
      { label: 'Fragrance', path: '/fragrance' },
      { label: 'Payment', path: '/waystopay' },
      { label: 'Contact', path: '/contact' },
    ]
  },

  nametags: {
    includePronouns: true,
    includeLastName: true
  },

  registration: {
    waitlistMode: true,
    showPreregistration: false,
    showWaiver: false,
    admissionQuantityMax: 4,
    fields: { // Order of form fields
      contact: ['first', 'last', 'nametag', 'pronouns', 'email', 'emailConfirmation', 'phone', 'address', 'apartment', 'city', 'state', 'zip', 'country'],
      misc: ['volunteer', 'hospitality', 'scholarship', 'comments']
    }
  },

  admissions: {
    mode: 'fixed', // sliding-scale|fixed|tiered
    slidingScale: {
      costRange: [120, 500],
      costDefault: 350
    },
    fixed: {
      cost: 60
    },
    tiered: {
      earlybirdCutoff: '2025-11-10', // last day to get early pricing
    }
  },

  payments: {
    processor: 'paypal', // stripe|paypal - also must set in backend config
    paymentDueDate: 'Example Payment Due Date',
    directPaymentUrl: 'paypal.me/PortlandBall', // electronic payment option to pay remaining balance after selecting deposit or check payment
    coverFeesCheckbox: false,
    showPaymentSummary: false, // show summary of costs in payment section
    deposit: {
      enabled: false,
      amount: 50 // ignored if disabled
    },
    donation: {
      enabled: true,
      max: 999 // ignored if disabled
    },
    checks: {
      allowed: true, // If false, the below fields are ignored
      showPostalAddress: true, // If false, shows contact email
      payee: 'Portland ECD Ball',
      address: ['David Macemon', '19936 Derby St', 'West Linn, OR 97068']
    }
  }
};

export default config;